import { render, staticRenderFns } from "./EntitiesTable.vue?vue&type=template&id=140b9d9d&"
import script from "./EntitiesTable.vue?vue&type=script&lang=js&"
export * from "./EntitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports